import { createContext } from "react";
import type { Translator } from "./translator";

export const I18nContext = createContext<Translator | null>(null);
